// 3rd party
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { MatSidenav, MatSnackBar } from '@angular/material';
import { MediaChange, ObservableMedia } from '@angular/flex-layout';
import { Subscription } from 'rxjs/Subscription';

// components
import { AppComponent } from 'app/app.component';

// services
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DialogsService } from 'app/shared/services/dialog/dialog.service';
import { LayoutMainService } from './shared/layout-main.service';
import { TranslateService } from '@ngx-translate/core';

// settings
import { environment } from 'environments/environment';

@Component({
  selector: 'app-layout-main',
  templateUrl: './layout-main.component.html',
  styleUrls: ['./layout-main.component.scss']
})
export class LayoutMainComponent implements OnInit, OnDestroy {

  @ViewChild('sidenav') sidenav: MatSidenav;
  private themeWrapper = document.querySelector('body');
  public CLIENT_VERSION: string;
  isMobile: boolean = false;
  isOpen: boolean = true;
  langChange: string;
  langChangeError: string;
  subscribe: Subscription;
  subscribe2: Subscription;
  hasColors = false;
  hasLogo = false;
  isPng = false;
  currentYear = new Date().getFullYear();

  logo: string = '';

  constructor(
    public app: AppComponent,
    private authService: AuthService,
    public dialog: DialogsService,
    public layoutMainService: LayoutMainService,
    public media: ObservableMedia,
    private router: Router,
    public snackBar: MatSnackBar,
    public translate: TranslateService
  ) {
    // no mobile, fecha o menu após a mudança de rota
    this.subscribe2 = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (this.isMobile) {
          this.sidenav.close();
        }
      }
    });
  }

  ngOnInit() {
    setTimeout(() => {
      this.hasLogo = JSON.parse(localStorage.getItem('hasSiteLogo'));
      this.themeWrapper.className = localStorage.getItem('themeName');
      this.isPng = localStorage.getItem('typelogosite') === 'png';

      if (this.hasLogo)
        this.logo = localStorage.getItem('logosite');
    }, 800);

    this.isOpen = this.media.isActive('gt-md');

    this.subscribe = this.media.subscribe((change: MediaChange) => {
      this.isMobile = (change.mqAlias === 'xs') || (change.mqAlias === 'sm') || (change.mqAlias === 'md');
      this.isOpen = !(this.isMobile || (change.mqAlias === 'sm'));
    });
    this.CLIENT_VERSION = environment.clientVersion;
  }

  ngOnDestroy() {
    this.subscribe.unsubscribe();
    if (this.subscribe2) {
      this.subscribe2.unsubscribe();
    }
  }

  changeLanguage(lang: string) {
    if (this.translate.currentLang === lang) {
      return;
    }
    this.layoutMainService.changeLanguage(lang).subscribe(res => {
      if (res) {
        this.translate.get('Translate.LanguageChange').subscribe((val) => {
          this.langChange = val;
          this.snackBar.open(this.langChange, 'Ok', {
            duration: 2000,
          });
        });
      } else {
        this.translate.get('Translate.ErrorOcurred').subscribe((val) => {
          this.langChangeError = val;
          this.snackBar.open(this.langChangeError, 'Ok', {
            duration: 2000,
          });
        });
      }
    });
  }

  changePassword() {
    this.dialog.changePassword().subscribe();
  }

  logoff() {
    this.authService.logoff();
    this.app.refreshSystemLanguage();
  }

  toggleSidenav() {
    this.sidenav.toggle();
  }

  openVideoModal() {
    this.dialog.openVideoDialog();
  }

  openPopupModal() {
    this.dialog.openPopupDialog();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/layout-main/layout-main.component.ts